import React from 'react'

export const NoWrapText: React.FC = ({ children }) => {
  return <span style={{ whiteSpace: 'nowrap' }}>{children}</span>
}
